import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {AppUrlConstants} from "../../../core/constants/AppUrlConstants";
import {Division} from "../../../core/models/division.model";
import {AlertDialogComponent} from "../../../shared/alert-dialog/alert-dialog.component";
import {GenericCrudService} from "../../../core/services/generic-crud.service";

@Component({
  selector: 'app-add-edit-dialog-division',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    ReactiveFormsModule, MatDialogClose, TranslateModule, MatCheckbox],
  templateUrl: './add-edit-division.component.html'
})
export class AddEditDivisionComponent {
  form: FormGroup;
  segmentType:string = "NONE";
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddEditDivisionComponent>,
      public dialog: MatDialog, private formBuilder: FormBuilder,
      private crudService: GenericCrudService) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      adminStrId: [null],
      name: ['', [Validators.required, Validators.maxLength(60)]],
      description: ['', [Validators.required, Validators.maxLength(300),]],
      parentAdminStrId:[],
      pulse: [false],
      plra: [false],
      segmentType:[],
      adminStructureTypes: "DIVISION"
    });
    if(this.data!=null){
      this.updateSegment(this.data);
      this.form.patchValue({
        adminStrId: this.data.adminStrId,
        name: this.data.name,
        description: this.data.description,
        parentAdminStrId: this.data.parentAdminStrId,
        pulse: this.data.pulse,
        plra: this.data.plra
      });
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
  add() {
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.division});
    console.log(this.form.value);
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        debugger;
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    debugger;
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.division});
    console.log(this.form.value);
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  setSegment(result: any){
    if (result.pulse && result.plra) {
      this.segmentType = 'ALL';
    } else if (!result.pulse && !result.plra) {
      this.segmentType = 'NONE';
    } else {
      this.segmentType = result.pulse ? 'PULSE' : 'PLRA';
    }
  }
  updateSegment(updateRecord: Division){
    switch (updateRecord.segmentType) {
      case 'ALL':
        updateRecord.pulse = true;
        updateRecord.plra = true;
        break;
      case 'NONE':
        updateRecord.pulse = false;
        updateRecord.plra = false;
        break;
      case 'PULSE':
        updateRecord.pulse = true;
        updateRecord.plra = false;
        break;
      case 'PLRA':
        updateRecord.pulse = false;
        updateRecord.plra = true;
        break;
      default:
        // Handle any other cases if needed
        break;
    }
  }
}
